<template>
  <div class="door-picker step-cards">
    <b-card
      v-for="door in doors"
      :key="door.id"
      no-body
      :img-src="door.image"
      class="door-card linked-card"
      :class="{ active: currentSavedDoor && currentSavedDoor.id === door.id }"
    >
      <a @click.prevent="handlePicked(door)" class="card-link"></a>

      <b-btn
        v-if="door.id && (!currentSavedDoor || currentSavedDoor.id !== door.id)"
        variant="primary"
        @click.prevent="handleRemove(door)"
        class="btn-overlay btn-overlay--top-right"
      >
        <i class="fa fa-trash" />
      </b-btn>
      <maintain-aspect-ratio
        v-else-if="!door.id"
        :width="16"
        :height="9"
        class="card-header card-img btn-card"
      >
        <div class="d-flex flex-column justify-content-center align-items-center">
          <i class="fa fa-plus-circle fa-2x mb-1" />
          <div>{{ door.name }}</div>
        </div>
      </maintain-aspect-ratio>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import MaintainAspectRatio from '@/components/utility/MaintainAspectRatio';

export default {
  name: 'door-picker',
  data() {
    return {
      savedDoors: [],
    };
  },
  computed: {
    ...mapState([
      'currentSavedDoor',
      'currentLayer',
    ]),
    ...mapGetters([
      'currentProduct',
    ]),

    doors() {
      return [{
        name: 'Add New Door',
      }].concat(...this.savedDoors);
    },
  },
  methods: {
    ...mapMutations([
      'setCurrentSavedDoor',
    ]),
    handlePicked(door) {
      if (door.id) {
        this.$emit('picked', door);
      } else {
        this.$emit('create');
      }
    },
    handleRemove(door) {
      this.$root.confirm('Are you sure you want to delete this item?').then(() => {
        this.$emit('remove', door);
      });
    },
  },
  async created() {
    // is only created once a login event has been detected, so handle anon doors here
    if (window.Renoworks.User.loggedIn) {
      // save current product, if any
      if (this.currentProduct) {
        if (this.currentSavedDoor) {
          // update existing product, if found
          window.Renoworks.User
            .updateProduct(this.currentSavedDoor.id, this.currentProduct, this.currentLayer.name);
        } else {
          // otherwise, save new product
          // must have a valid rendered image or save will fail
          if (!this.currentProduct.renderedImage) {
            this.currentProduct.renderedImage = this.currentProduct.thumbnail;
          }
          const doorID = await window.Renoworks.User
            .saveProduct(this.currentProduct, this.currentLayer.name);
          this.savedDoors = window.Renoworks.User.getProducts();
          const door = this.savedDoors.find(s => s.id === doorID);
          this.setCurrentSavedDoor(door);
        }
      }
      this.savedDoors = window.Renoworks.User.getProducts();
    }

    // handle sign-out if the event is caught before component destruction
    window.jQuery(window.Renoworks.Event).on(window.Renoworks.Event.USER_LOADED, () => {
      if (!window.Renoworks.User.loggedIn) {
        // eslint-disable-next-line no-lonely-if
        if (this.currentSavedDoor) {
          // clear current saved door
          this.setCurrentSavedDoor(null);
        }
      }
    });

    // keep user products list synced with CF
    window.jQuery(window.Renoworks.Event).on(window.Renoworks.Event.USER_PRODUCTS_UPDATED, () => {
      if (window.Renoworks.User.loggedIn) {
        this.savedDoors = window.Renoworks.User.getProducts();
      }
    });
  },
  components: {
    MaintainAspectRatio,
  },
};
</script>

<style lang="scss">
.door-picker {

}
</style>



// WEBPACK FOOTER //
// src/components/DoorPicker.vue